module.exports = __webpack_public_path__ + "../resources/img/img_visual02.a850f145.jpg";